import { Image } from "@components/Image/Image";
import { Link } from "@components/Link/Link";
import { styledWithInvalidProps } from "@components/Styled/StyledWithInvalidProps";
import { StyledH4, StyledP } from "@components/Styled/Text";
import React from "react";
import tw from "twin.macro";
import {
  ImageGridCardOutputProps,
  withImageGridCard,
} from "./withImageGridCard";

const styles = {
  cols: {
    "1": tw`w-full`,
    "2": tw`w-1/2`,
    "3": tw`w-1/2 md:w-1/3`,
    "4": tw`w-1/2 md:w-1/4 xl:w-1/4`,
    "5": tw`w-1/2 md:w-1/4 xl:w-1/5`,
    "6": tw`w-1/2 md:w-1/4 xl:w-1/6`,
  },
};

const Wrapper = styledWithInvalidProps("div")(
  ({ spacing, cols, textColour }) => [
    tw`relative flex flex-col`,
    spacing ? tw`p-micro sm:p-mini` : null,
    cols && styles.cols[cols] ? styles.cols[cols] : styles.cols["4"],
    textColour === `lightest` ? tw`text-white` : tw`text-primary`,
  ],
);

const ImageTitle = tw(StyledH4)`
  absolute z-10 left-midi top-maxi text-h4 font-display cursor-pointer lg:text-[32px] md:top-maxi md:left-mega 
`;

const ImageWrapper = tw.div`w-full relative`;

const ImageLinkText = tw(StyledP)`
  absolute z-10 border-b cursor-pointer left-midi bottom-midi hover:text-white md:bottom-maxi md:left-mega
`;

const ImageGridCard = withImageGridCard(
  ({
    spacing,
    cols,
    handleClickImage,
    textColour,
    images,
  }: ImageGridCardOutputProps) => (
    <>
      {images.map(({ image, imageLink, imageLinkTitle, imageTitle }, index) => {
        return (
          <Wrapper
            key={index}
            spacing={spacing ? "true" : undefined}
            cols={cols}
            textColour={textColour}
          >
            <ImageWrapper>
              {imageTitle && <ImageTitle role="title">{imageTitle}</ImageTitle>}
              <Image
                image={image}
                alt={image.alt}
                ratio="11/12"
                imageLink={imageLink}
                onClick={handleClickImage}
              />
              {imageLink && (
                <ImageLinkText as={Link} to={imageLink?.url} role="link">
                  {imageLinkTitle}
                </ImageLinkText>
              )}
            </ImageWrapper>
          </Wrapper>
        );
      })}
    </>
  ),
);

export default ImageGridCard;
